module.exports = __webpack_public_path__ + "img/vertical_7_5_6000.3bcbe613.png";